import React from 'react';
import axios from 'axios';
import 'antd/dist/antd.css';
import './index.css';
import {ConfigProvider, InputNumber} from 'antd';
import esES from 'antd/lib/locale/es_ES';
import {
    Tag,
    List,
    DatePicker,
    Spin,
    Button,
    Layout,
    Breadcrumb,
    Table,
    Select,
    message,
    Divider,
    Tabs,
    Radio,
    Upload,
    Progress,
    Popconfirm
} from 'antd';
import {Drawer, Form, Col, Row, Input, Avatar} from 'antd';
import reqwest from 'reqwest';
import {useState} from 'react';
import {useEffect} from 'react';
import MyMenu from '../../components/Menu';
import {PlusOutlined, MinusOutlined, UploadOutlined, DeleteOutlined, UserOutlined} from '@ant-design/icons';
import {useHistory} from "react-router-dom";
import config from '../../config'

//import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import {GoogleMap, LoadScript, Autocomplete, Marker} from '@react-google-maps/api';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import {getToken} from '../../Utils/common';

import Moment from 'moment';
import {extendMoment} from 'moment-range';
import 'moment/locale/es';
import Appointment from "../../components/Appointment";
import PatientProgress from "../../components/PatientProgress";
import PatientTypeHistory from "../../components/PatientTypeHistory";


const moment = extendMoment(Moment);
moment.locale('es');

const {Option} = Select;
const {Content, Sider, Header} = Layout;
const {Search} = Input;
const {TabPane} = Tabs;

const os = ['OSDE', 'Swiss Medical', 'PAMI'];

// Table
const columns = [
    {
        title: 'Estado',
        dataIndex: 'status',
    },
    // {
    //     title: 'Tipo',
    //     dataIndex: 'pacient_type',
    // },
    {
        title: 'Obra Social',
        dataIndex: 'medical_insurance_name',
    },
    {
        title: 'Afiliado Nro.',
        dataIndex: 'medical_id',
    },
    {
        title: 'Nombre',
        dataIndex: 'name',
        sorter: true,
        width: '20%',
    },
    {
        title: 'Apellido',
        dataIndex: 'last_name',
        sorter: true,
        // render: name => `${name.name} ${name.last_name}`,
        width: '20%',
    },
    {
        title: 'Documento',
        dataIndex: 'document',
    },
    {
        title: 'Tel. Ppal.',
        dataIndex: 'phone',
    },
    {
        title: 'Tel. Sec.',
        dataIndex: 'alternative_phone_1',
    },
    {
        title: 'Psicologia',
        dataIndex: 'current_psychology_sessions',
        render: (text, record, index) => {
            if (record.psychology_treatment_status !== "A") {
                return "-"
            } else {
                return `${record.current_psychology_sessions}/${record.total_psychology_sessions}`
            }
        },
    },
    {
        title: 'Psiquiatria',
        dataIndex: 'current_psychiatry_sessions',
        render: (text, record, index) => {
            if (record.psychiatry_treatment_status !== "A") {
                return "-"
            } else {
                return `${record.current_psychiatry_sessions}/${record.total_psychiatry_sessions}`
            }
        },
    }//,
    // {
    //     title: 'Copago',
    //     dataIndex: 'copago',
    //     render: (text, record, index) => {
    //         if (record.copago === 'Y') {
    //             return "Si"
    //         } else {
    //             return "No"
    //         }
    //     },
    // }
];


function getAddressObject(address_components) {
    var ShouldBeComponent = {
        home: ["street_number"],
        postal_code: ["postal_code"],
        street: ["street_address", "route"],
        city: [
            "administrative_area_level_1",
        ],
        comuna: [
            "administrative_area_level_2",
        ],
        locality: [
            "locality",
        ],
        neighborhood: [
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
        ],
        country: ["country"]
    };

    var address = {
        home: "",
        postal_code: "",
        street: "",
        region: "",
        city: "",
        country: ""
    };
    address_components.forEach(component => {
        for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                    address[shouldBe] = component.short_name;
                } else {
                    address[shouldBe] = component.long_name;
                }
            }
        }
    });
    return address;
}

function Pacients(props) {

    const defaultCenter = {
        lat: -34.6037, lng: -58.3816
    }
    const [expand, setExpand] = useState(true);
    const [treatmentProfesionalAppointment, setTreatmentProfesionalAppointment] = useState();

    const [data, setData] = useState([]);
    const [appointmentsData, setAppointmentsData] = useState([]);

    const [spinning, setSpinning] = useState(false);
    const [place, setPlace] = useState({});
    const [filters, setFilters] = useState('&status_param=A&search=');
    const [currentPosition, setCurrentPosition] = useState(defaultCenter);
    const [zoom, setZoom] = useState(12)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const [pacientAppointmentPagination, setPacientAppointmentPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [loadingSaveButton, setLoadingSaveButton] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [visible, setVisible] = useState();
    const [deleteVisible, setDeleteVisible] = useState();
    const [fileList, setFileList] = useState([]);
    const [photoUrl, setPhotoUrl] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [visibleSearch, setVisibleSearch] = useState(false);
    const [visibleAppointment, setVisibleAppointment] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showDestroyedFields, setShowDestroyedFields] = useState(false);
    const [showPsychiatryFields, setShowPsychiatryFields] = useState(false);
    const [showPsychologyFields, setShowPsychologyFields] = useState(false);
    const [showClinicFields, setShowClinicFields] = useState(false);
    const [showAdmisorFields, setShowAdmisorFields] = useState(false);
    const [active, setActive] = useState(0);
    const [formData, setFormData] = useState({});
    const [childrenDrawer, setChildrenDrawer] = useState(false);
    const [useMap, setUseMap] = useState(false);
    const [form] = Form.useForm();
    const [searchform] = Form.useForm();
    const [appointmentform] = Form.useForm();
    const [formMaps] = Form.useForm();
    const [fastSearchForm] = Form.useForm();
    const [autocomplete, setAutocomplete] = useState(null);

    const [profesionals, setProfesionals] = useState([]);
    const [admisors, setAdmisors] = useState([]);

    const [fetchingProfesionals, setFetchingProfesionals] = useState(false);
    const [fetchingAdmisors, setFetchingAdmisors] = useState(false);

    const [medicalInsurances, setMedicalInsurances] = useState([]);
    const [medicalInsuranceSelected, setMedicalInsuranceSelected] = useState([])
    const [fetchingMedicalInsurance, setFetchingMedicalInsurance] = useState(false);

    const [admisorSelected, setAdmisorSelected] = useState([])
    const [profesionalSelected, setProfesionalSelected] = useState([])
    const [slotsTaken, setSlotsTaken] = useState([])
    const [profesionalWorkingHours, setProfesionalWorkingHours] = useState([])
    const [pacientAppointments, setPacientAppointments] = useState([])
    const [activeTab, setActiveTab] = useState("1")
    const [patientStatus, setPatientStatus] = useState("A");
    const [fastSearchValue, setFastSearchValue] = useState("")
    const [appointmentVisible, setAppointmentVisible] = useState(false);
    const [appointmentId, setAppointmentId] = useState(0);

    const history = useHistory();

    const fetchProfesionals = (params = {}, props) => {
        setFetchingProfesionals(true);
        setFetchingAdmisors(true);
        //setProfesionals([]);


        if (params)
            params = `&search=${params}`

        reqwest({
            url: `${config.api_url}/profesionals/?limit=1000${params}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                // console.log("PARAMS IN FETCH");
                // console.log(params);
                // console.log(data);
                setFetchingProfesionals(false);
                const profesionals_data = data.results.map(user => ({
                    text: `${user.name} ${user.last_name}`,
                    value: user.id,
                }));
                // console.log("profesionals_data")
                // console.log(profesionals_data);

                setProfesionals(profesionals_data);

            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const fetchMedicalInsurances = (params = {}, props) => {
        setFetchingProfesionals(true);
        setFetchingAdmisors(true);

        if (params)
            params = `&search=${params}`

        reqwest({
            url: `${config.api_url}/medicalinsurance/?limit=1000${params}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                // console.log("PARAMS IN FETCH");
                // console.log(params);
                // console.log(data);
                setFetchingProfesionals(false);
                const medicalinsurances_data = data.results.map(user => ({
                    text: `${user.short_name}`,
                    value: user.id,
                }));
                // console.log("medicalinsurance_data")
                // console.log(medicalinsurances_data);

                setMedicalInsurances(medicalinsurances_data);

            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };


    const fetchAdmisors = (params = {}, props) => {
        setFetchingAdmisors(true);
        setAdmisors([]);

        if (params)
            params = `?search=${params}`

        reqwest({
            url: `${config.api_url}/profesionals/?admisor=true`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                // console.log("PARAMS IN FETCH");
                // console.log(params);


                // console.log(data);
                setFetchingAdmisors(false);
                const admisors_data = data.results.map(user => ({
                    text: `${user.name} ${user.last_name}`,
                    value: user.id,
                }));
                // console.log("admisors_data")
                // console.log(admisors_data);

                setAdmisors(() => admisors_data);

            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los admisores.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const mapStyles = {
        height: "80vh",
        width: "100%"
    };

    const onLoad = (autocomplete_instance) => {
        // console.log("Loaded autocomplete");
        if (autocomplete === null) {
            setAutocomplete(autocomplete_instance)
            setCurrentPosition(defaultCenter)
        }
    }

    const onPlaceChanged = () => {
        // setPlace( () => autocomplete.getPlace())
        const place = autocomplete.getPlace();
        if (!place.geometry) {
            alert("Debe seleccionar un domicilio.")
            return
        }
        setDisabled(false);
        setCurrentPosition({'lat': place.geometry.location.lat(), 'lng': place.geometry.location.lng()});
        setZoom(18)
    }

    useEffect(() => {
        fetch({'pagination': pagination, 'filters': filters}, props)
        fetchProfesionals("")
        fetchAdmisors("")
        fetchMedicalInsurances("")
    }, []);

    function onClose() {
        // console.log("Closing drawer");
        setActiveTab("1")
        setVisible(false);
    }

    function onCloseSearch() {
        // console.log("Closing search drawer");
        setVisibleSearch(false);
    }

    function onCloseAppointment() {
        // console.log("Closing appointment drawer");
        setVisibleAppointment(false);
    }

    function onSave() {
        // console.log("Saving data in drawer");
        // console.log(form.getFieldsValue());
        form.validateFields()
            .then(
                values => {
                    update_pacient(form.getFieldsValue());
                }
            ).catch(
            errorInfo => {
                console.log(errorInfo);
            }
        );
    }


    const fetch = (params = {}, props) => {
        setLoading(true);
        setActive(9);

        let offset = '';

        if (params.pagination.current > 1) {
            // console.log(params.pagination)
            offset = `&offset=${pagination.pageSize * (params.pagination.current - 1)}`
        }

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend")
                direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }

        reqwest({
            url: `${config.api_url}/pacients/?limit=${params.pagination.pageSize}${offset}${params.filters}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log("PARAMS IN FETCH");
            // console.log(params);


            // console.log(data);
            setLoading(false);
            setData(data.results);
            setPagination({
                'total': data.count,
                'current': params.pagination.current,
                'pageSize': params.pagination.pageSize
            })
            // console.log(pagination);

        }).catch((errorInfo) => {
            setLoading(false);
            // console.log( "Error info")
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los residentes.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const isReadOnly = patientStatus !== 'A';

    const fetch_by_id = (id = {}) => {
        setLoading(true);
        setSpinning(true);
        setFileList([]);
        setPhotoUrl(null);
        // this.setState({ loading: true });
        reqwest({
            url: config.api_url + '/pacients/' + id + '?status_param=T',
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log(data);
            setVisible(true);
            setDeleteVisible(true)
            setLoading(false);
            setSpinning(false);

            if (data.photo) {
                setPhotoUrl(data.photo);
            }

            // Normalize and set form values in one pass to avoid passing strings to DatePicker
            setPatientStatus(data.status);
            const normalizedData = {
                ...data,
                birth_date: data.birth_date ? moment(data.birth_date, 'YYYY-MM-DD') : null,
                age: typeof data.age !== 'undefined' ? data.age : null,
            };
            form.setFieldsValue(normalizedData);
            if (data.status === "B") {
                setShowDestroyedFields(true);
            } else {
                setShowDestroyedFields(false);
            }

            if (data.psychiatry_treatment_status === "A") {
                setShowPsychiatryFields(true);
                if (data.current_psychiatry_sessions <= 3) {
                    alert(`Al residente le queda/n ${data.current_psychiatry_sessions} sesion/es psiquiatricas`)
                }
            } else {
                setShowPsychiatryFields(false);
            }

            if (data.psychology_treatment_status === "A") {
                setShowPsychologyFields(true);
                if (data.current_psychology_sessions <= 3) {
                    alert(`Al residente le queda/n ${data.current_psychology_sessions} sesion/es psicologicas`)
                }
            } else {
                setShowPsychologyFields(false);
            }

            if (data.admision_treatment_status === "A") {
                setShowAdmisorFields(true);
            } else {
                setShowAdmisorFields(false);
            }

            if (data.clinic_status === "A") {
                setShowClinicFields(true);
            } else {
                setShowClinicFields(false);
            }
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener el residente.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
        ;
    };

    const update_pacient = (pacient = {}) => {
        setLoadingSaveButton(true);
        let url = "";
        let method = "";

        if (pacient.id > 0) {
            url = config.api_url + '/pacients/' + pacient.id + '/';
            method = 'patch';
        } else {
            url = config.api_url + '/pacients/';
            method = 'post';
        }

        const formData = new FormData();

        // Normalize fields and append to FormData
        Object.keys(pacient).forEach(key => {
            let value = pacient[key];
            if (key === 'birth_date' && value && value._isAMomentObject) {
                value = value.format('YYYY-MM-DD');
            }
            if (key === 'age') return; // skip computed field

            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });

        // Handle photo
        if (fileList.length > 0) {
            formData.append('photo', fileList[0]);
            setIsUploading(true);
            setUploadProgress(0);
        } else if (photoUrl === null && pacient.id > 0) {
            // If photo was explicitly removed
            formData.append('photo', '');
        }

        axios({
            url: url,
            method: method,
            data: formData,
            headers: {
                'Authorization': `Token ${getToken()}`,
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                if (fileList.length > 0) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                }
            }
        }).then(response => {
            const data = response.data;
            setLoadingSaveButton(false);
            setIsUploading(false);
            setUploadProgress(0);
            setDeleteVisible(true)
            message.success("Actualizacion correcta")

            if (data.photo) {
                setPhotoUrl(data.photo);
            } else {
                setPhotoUrl(null);
            }
            setFileList([]);

            // Normalize and set form values in one pass to avoid passing strings to DatePicker
            const normalizedDataAfterSave = {
                ...data,
                birth_date: data.birth_date ? moment(data.birth_date, 'YYYY-MM-DD') : null,
                age: typeof data.age !== 'undefined' ? data.age : null,
            };
            form.setFieldsValue(normalizedDataAfterSave)

            const _filters = getFormFilters()
            fetch({pagination, 'filters': _filters})

        })
            .catch(
                error => {
                    setLoadingSaveButton(false);
                    setIsUploading(false);
                    setUploadProgress(0);
                    let error_detail_txt = "";
                    if (error.response && error.response.data) {
                        const error_detail_obj = error.response.data;
                        Object.entries(error_detail_obj).forEach(([k, v]) => {
                            error_detail_txt = `${error_detail_txt}${k}: `;
                            if (Array.isArray(v)) {
                                v.forEach((value) => {
                                    error_detail_txt = `${error_detail_txt}(${value}) `;
                                })
                            } else {
                                error_detail_txt = `${error_detail_txt}${v}`;
                            }
                            error_detail_txt = `${error_detail_txt}\n`;
                        });
                    } else {
                        error_detail_txt = error.message;
                    }
                    message.error(`Ha ocurrido un error al intentar guardar el residente.\nDetalle: ${error_detail_txt}`);
                }
            );
    };


    const handleTableChange = (pagination, filters, sorter) => {
        const _filters = getFormFilters()
        // console.log('search button ' + _filters);
        // console.log(pagination);

        fetch({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            'filters': _filters
        });
    };

    const handlePacientAppointmentsTableChange = (pagination, filters, sorter) => {
        fetchPacientAppointments(
            form.getFieldValue("id"),
            {
                pagination: pagination,
            });
    };

    const showDrawer = (user_id = 0) => {
        //if (user_id > 0){
        fetch_by_id(user_id);


        //this.setState( {user_id: 0, visible: false});
        //}
        //this.setState( {user_id: user_id, visible: true});
    }

    const showDrawerCreate = () => {
        form.resetFields();
        form.setFieldsValue({
            psychiatry_treatment_status: 'NA',
            psychology_treatment_status: 'NA',
            birth_date: null,
            age: null,
        })
        setShowPsychologyFields(false)
        setShowPsychiatryFields(false)
        setFileList([]);
        setPhotoUrl(null);
        setVisible(true);
        setDeleteVisible(false)
        setPatientStatus('A');
    }

    const showDrawerSearch = () => {
        setVisibleSearch(true);
    }

    const compressImage = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;

                    // Max resolution 600x600
                    const MAX_WIDTH = 600;
                    const MAX_HEIGHT = 600;

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // Quality adjustment to hit target weight (~200KB)
                    canvas.toBlob((blob) => {
                        if (blob) {
                            const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".webp", {
                                type: 'image/webp',
                                lastModified: Date.now(),
                            });
                            resolve(compressedFile);
                        } else {
                            reject(new Error("Canvas toBlob failed"));
                        }
                    }, 'image/webp', 0.8);
                };
                img.onerror = (err) => reject(err);
            };
            reader.onerror = (err) => reject(err);
        });
    };

    const showDrawerAppointment = (prof) => {

        if (prof == 'admision') {
            history.push("/appointments/");
        }

        if (prof === 'psychology_treatment_profesional') {
            if (!showPsychologyFields) {
                message.error("Debe dar de alta un tratamiento psicologico");
                return
            }
            appointmentform.setFieldsValue({motive: 'CA'})
        }

        if (prof === 'psychiatry_treatment_profesional') {
            if (!showPsychiatryFields) {
                message.error("Debe dar de alta un tratamiento psiquiatrico");
                return
            }
            appointmentform.setFieldsValue({motive: 'CA'})
        }


        setVisibleAppointment(true);
        setTreatmentProfesionalAppointment(prof);
        setSlotsTaken([]);
        setAppointmentsData([]);
    }

    const showChildrenDrawer = () => {
        setChildrenDrawer(true);
    }

    const onChildrenDrawerClose = () => {
        // If user cancels without selecting an address (Confirm disabled), turn off map mode to prevent auto-reopen
        if (useMap && disabled) {
            setUseMap(false);
        }
        setChildrenDrawer(false);
    }


    const showStates = () => {
        // console.log("");
    }

    const onCollapse = collapsed => {
        // console.log(collapsed);
        setCollapsed((prevCollapsed) => {
            return !prevCollapsed
        });
    };


    const init_psychology_treatment = () => {
        // console.log("init psycology treatment")
        form.setFieldsValue(
            {
                'total_psychology_sessions': '',
                'current_psychology_sessions': '',
                'psychology_treatment_profesional': ''
            });
    }

    const init_psychiatry_treatment = () => {
        // console.log("init psychiatry treatment")
        form.setFieldsValue(
            {
                'total_psychiatry_sessions': '',
                'current_psychiatry_sessions': '',
                'psychiatry_treatment_profesional': ''
            });
    }

    const onStatuChange = status => {
        // console.log("Status " + status);
        setPatientStatus(status);
        form.setFieldsValue({'destroyed_cause': '', 'file_location': ''});
        if (status === "B") {
            setShowDestroyedFields(true);
            message.warning("Al pasar a estado Baja, las internaciones activas pasarán al estado 'Baja Residente'");
        } else if (status === "I") {
            setShowDestroyedFields(false);
            message.warning("Al pasar a estado Inactivo, las internaciones activas pasarán al estado 'Residente Inactivo'");
        } else if (status === "S") {
            setShowDestroyedFields(false);
            message.info("Estado: Salida Temporal. Las internaciones activas NO se inactivarán.");
        } else {
            setShowDestroyedFields(false);
        }
    }

    const buildAddr = (addr_obj) => {
        let addr = `${addr_obj.street} ${addr_obj.home}`

        if (addr_obj.neighborhood) {
            addr = `${addr}, ${addr_obj.neighborhood}`
        }

        if (addr_obj.locality) {
            addr = `${addr}, ${addr_obj.locality}`
        }

        if (addr_obj.city) {
            addr = `${addr}, ${addr_obj.city}`
        }

        return addr;
    }

    const onConfirmAddress = () => {
        // console.log("Confirmed addr");
        const place = autocomplete.getPlace()
        // console.log(place.address_components);
        const addr_obj = getAddressObject(place.address_components);
        const addr = buildAddr(addr_obj);
        form.setFieldsValue({"address": `${addr}`})

        if (addr_obj.comuna) {
            form.setFieldsValue({"comuna": addr_obj.comuna})
        }

        message.success("Domicilio confirmado");
        setDisabled(true);
        setChildrenDrawer(false);
    }

    const handleOnChangeProfesional = value => {
        // setProfesionals([])
        setFetchingProfesionals(false)
        // console.log("Selected profesional");
        // console.log(value);

        setProfesionalSelected(value);
    }

    const handleOnChangeAdmisor = value => {
        setFetchingAdmisors(false)
        // console.log("Selected profesional");
        // console.log(value);

        setAdmisorSelected(value);
    }

    const onAdmisorStatusChange = status => {
        form.setFieldsValue({'total_admisor_sessions': '', 'current_admisor_sessions': ''});
        if (status === "A") {
            setShowAdmisorFields(true);
        } else {
            setShowAdmisorFields(false);
        }
    }

    const onPsychologyStatusChange = status => {
        form.setFieldsValue({'total_psychology_sessions': '', 'current_psychology_sessions': ''});
        if (status === "A") {
            setShowPsychologyFields(true);
        } else {
            setShowPsychologyFields(false);
        }

        if (status === "I") {
            init_psychology_treatment()
        }

    }

    const onPsychiatryStatusChange = status => {
        form.setFieldsValue({'total_psychiatry_sessions': '', 'current_psychiatry_sessions': ''});
        if (status === "A") {
            setShowPsychiatryFields(true);
        } else {
            setShowPsychiatryFields(false);
        }
    }

    const onClinicStatusChange = status => {
        if (status === "A") {
            setShowClinicFields(true);
        } else {
            setShowClinicFields(false);
        }
    }

    const onFastSearch = (value) => {
        // console.log('fast search button ' + value);
        setPagination({'total': 0, 'current': 0, 'pageSize': 0})
        if (!value) {
            onSearch()
        } else {
            setFastSearchValue(value)
            fetch({
                pagination,
                'filters': `&search=${value}`,
            });
        }
    }
    const onSearch = (value) => {

        const _filters = getFormFilters()
        // console.log('search button ' + _filters)
        fastSearchForm.resetFields()
        setFastSearchValue("")
        fetch({
            pagination,
            'filters': _filters,
        });
    }

    const clearFormFilters = () => {
        searchform.resetFields()
        fastSearchForm.resetFields()
        onSearch()
    }

    const getFormFilters = () => {
        let filters = searchform.getFieldsValue();
        let filter_params = "";
        if (filters['profesional']) {
            filters['psychiatry_treatment_profesional__last_name'] = filters['profesional'];
            filters['psychology_treatment_profesional__last_name'] = filters['profesional'];
        }
        if (filters['psychiatry_treatment_modality']) {
            filter_params = `${filter_params}&psychiatry_treatment_modality=${filters['psychiatry_treatment_modality']}`;
        }
        if (filters['psychology_treatment_modality']) {
            filter_params = `${filter_params}&psychology_treatment_modality=${filters['psychology_treatment_modality']}`;
        }
        if (filters['comuna']) {
            filter_params = `${filter_params}&comuna=Comuna ${filters['comuna']}`;
        }
        if (filters['pacient_type']) {
            filter_params = `${filter_params}&pacient_type=${filters['pacient_type']}`;
        }
        if (filters['psychiatry_treatment_profesional']) {
            filter_params = `${filter_params}&psychiatry_treatment_profesional=${filters['psychiatry_treatment_profesional']}`;
        }
        if (filters['psychology_treatment_profesional']) {
            filter_params = `${filter_params}&psychology_treatment_profesional=${filters['psychology_treatment_profesional']}`;
        }
        if (!filters['status']) {
            filter_params = `${filter_params}&status_param=A`;
        } else {
            filter_params = `${filter_params}&status_param=${filters['status']}`;
        }
        if (filters['document']) {
            filter_params = `${filter_params}&document=${filters['document']}`;
        }
        if (filters['medical_insurance']) {
            filter_params = `${filter_params}&medical_insurance=${filters['medical_insurance']}`;
        }
        return filter_params
    }


    const onSearchAppointment = (value) => {

        if (!form.getFieldValue(treatmentProfesionalAppointment)) {
            alert("Debe tener un profesional asignado");
            return
        }

        let in_days = appointmentform.getFieldValue('appointment_days')
        if (!in_days) {
            // console.log("No estaba seteado");
            appointmentform.setFieldsValue({appointment_days: 0})
        }

        if (value === 'next') {
            appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') + 7})
        } else if (value === 'previous') {
            if (in_days <= 0) {
                appointmentform.setFieldsValue({appointment_days: 0})
            } else {
                appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') - 7})
            }
        }

        let search_filters = appointmentform.getFieldsValue();

        // console.log(search_filters);

        let filters = {}

        let start_date_filter = null;
        let end_date_filter = null;
        if (!search_filters.appointment_days) {
            start_date_filter = moment(search_filters.appointment_range)
            end_date_filter = moment(search_filters.appointment_range)
        } else {
            // console.log( "desde " + search_filters.appointment_days);

            start_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
            end_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
        }

        // console.log(start_date_filter);
        filters['appointment_start'] = start_date_filter.startOf('week').format('YYYY-MM-DD 00:00');
        filters['appointment_end'] = end_date_filter.endOf('week').format('YYYY-MM-DD 23:59');


        //filters['pacient_profesional'] = form.getFieldValue('psychiatry_treatment_profesional');
        filters['pacient_profesional'] = form.getFieldValue(treatmentProfesionalAppointment);


        // console.log("Range");


        // s = `${s}&profesional=${pacient_profesional}&appointment_start=${moment(filters.appointment_range[0]._d).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(filters.appointment_range[1]._d).format('YYYY-MM-DD 23:59')}`;


        // console.log(filters);
        // // console.log('search appointments button ' + s);
        fetchAppointments({
            pagination,
            'filters': filters,
        });
    }

    const handleNewAppointment = (fecha, hora, modality, motive) => {
        // console.log("Nuevo turno solicitado para " + fecha + hora);
        // console.log(form.getFieldValue(treatmentProfesionalAppointment));
        // console.log(form.getFieldValue("id"));

        // TODO fix gmt -3
        // console.log(`${fecha}T${hora}:00`);
        const fecha_turno = moment(`${fecha} ${hora}:00`).add(3, "hours").format('YYYY-MM-DDTHH:mm:ss')
        // console.log(fecha_turno);

        let is_admision = false;
        if (treatmentProfesionalAppointment === 'admision_treatment_profesional') {
            is_admision = true;
        }

        let over_shift = false
        const minutes = hora.split(":")[1]
        if (minutes !== "30" && minutes !== "00") {
            //console.log("Es sobreturno")
            over_shift = true
        }

        const params = {
            // TODO: fix utc
            appointment_at: fecha_turno,
            pacient: form.getFieldValue("id"),
            profesional: form.getFieldValue(treatmentProfesionalAppointment),
            is_admision: is_admision,
            modality: modality,
            motive: motive,
            is_over_shift: over_shift,

        }
        fetchCreateAppointments(params)
    }

    const fetchCreateAppointments = (params) => {
        setLoadingList(true)
        reqwest({
            url: `${config.api_url}/appointments/`,
            method: 'post',
            type: 'json',
            data: params,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log(data)
            const s = [...slotsTaken, data]
            setSlotsTaken(s)
            //setLoadingList(false)
            onSearchAppointment()
        }).catch((errorInfo) => {
            setLoadingList(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar crear el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const handleDeleteAppointment = (id, tag_id) => {

        const params = {
            id: id,
            tag_id: tag_id
        }
        fetchDeleteAppointments(params)
    }

    const fetchDeleteAppointments = (params) => {
        setLoadingList(true)
        reqwest({
            url: `${config.api_url}/appointments/${params.id}`,
            method: 'delete',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log(data)
            let s = [...slotsTaken]
            s.splice(params.tag_id, 1)
            setSlotsTaken(s)
            setLoadingList(false)
            onSearchAppointment()
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar eliminar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const get_profesional_working_hours = (profesional_id) => {
        // console.log("Getting working hours");
        // console.log(profesional_id);

        reqwest({
            url: `${config.api_url}/profesionalworkingdays/?profesional_id=${profesional_id}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setProfesionalWorkingHours(() => data.results);
        })
    }


    const fetchPacientAppointments = (pacient_id = null, params = {}) => {
        let offset = '';
        // console.log(params.pagination)
        if (params.pagination.current > 1) {
            offset = `&offset=${pacientAppointmentPagination.pageSize * (params.pagination.current - 1)}`
        }
        reqwest({
            url: `${config.api_url}/appointments/?pacient_id=${pacient_id}&limit=${params.pagination.pageSize}${offset}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log(data);
            setPacientAppointments(data.results);
            setPacientAppointmentPagination({
                'total': data.count,
                'current': params.pagination.current,
                'pageSize': params.pagination.pageSize
            })
        });
    }

    const fetchAppointments = (params = {}) => {
        setLoadingList(true);

        let offset = '';
        if (params.pagination.current > 1)
            offset = `&offset=2000`

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend")
                direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }
        order = '&ordering=appointment_at'

        const filter_query = `&profesional=${params.filters.pacient_profesional}&appointment_start=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(params.filters.appointment_end).format('YYYY-MM-DD 23:59')}`;


        reqwest({
            url: `${config.api_url}/appointments/scheduler_by_week/?limit=2000${offset}${filter_query}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setLoadingList(false);
            let all_appointments = []
            data.results.forEach((element) => {
                let current_date = moment(element.appointment_at).format("YYYY-MM-DD")
                const current_hour = moment(element.appointment_at).format('HH:mm')
                let fecha = Object.keys(all_appointments).find(key => {
                    return all_appointments[key].hasOwnProperty(current_date)
                });
                if (!fecha) {
                    let a = {}
                    a[current_date] = {}
                    all_appointments.push(a)
                    fecha = all_appointments.length - 1
                }
                // console.log("********************");
                // console.log(fecha);
                // console.log(current_date);
                // console.log(current_hour);
                // console.log(all_appointments);
                // console.log("********************");
                if (all_appointments[fecha][current_date]) {
                    // console.log(element)
                    all_appointments[fecha][current_date][current_hour] = []
                    all_appointments[fecha][current_date][current_hour].push(element.modality)
                    all_appointments[fecha][current_date][current_hour].push(element)
                }
            })
            setAppointmentsData(all_appointments);
            // console.log("All appointmens final");
            // console.log(all_appointments);
        }).catch((errorInfo) => {
            setLoadingList(false);
            message.error(`Ha ocurrido un error al intentar obtener los turnos.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const fetchAppointments2 = (params = {}) => {
        setLoadingList(true);

        let offset = '';
        if (params.pagination.current > 1)
            offset = `&offset=2000`

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend")
                direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }
        order = '&ordering=appointment_at'

        const filter_query = `&profesional=${params.filters.pacient_profesional}&appointment_start=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(params.filters.appointment_end).format('YYYY-MM-DD 23:59')}`;


        reqwest({
            url: `${config.api_url}/appointments/scheduler_by_week/?limit=2000${offset}${filter_query}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // console.log(moment(params.filters.appointment_start).format('dd'))

            // range to show
            let range = moment.range(params.filters.appointment_start, params.filters.appointment_end)

            //get_profesional_working_hours(params.filters.pacient_profesional);
            //// console.log("profesional hours");
            reqwest({
                url: `${config.api_url}/profesionalworkingdays/?profesional_id=${params.filters.pacient_profesional}`,
                method: 'get',
                type: 'json',
                headers: {
                    'Authorization': `Token ${getToken()}`,
                }
            }).then(wh => {
                //Grid
                // all_appointments = []
                // all_appointments.push(...data.results)
                const profesionalWorkingHours2 = wh.results
                let working_hours_table = {'lu': {}, 'ma': {}, 'mi': {}, 'ju': {}, 'vi': {}}
                profesionalWorkingHours2.forEach((val, ind, arr) => {
                    // console.log("diff");
                    // console.log(val.hour_from);
                    // console.log(val.hour_to);
                    // console.log(moment(val.hour_to, "HH:mm:ss").diff(moment(val.hour_from, "HH:mm:ss"), 'hours'))
                    let hours_diff = moment(val.hour_to, "HH:mm:ss").diff(moment(val.hour_from, "HH:mm:ss"), 'hours')
                    let hour_from = moment(val.hour_from, "HH:mm:ss")
                    let intervals_iterations = 2
                    let intervals_minutes = 30
                    if (val.over_shifts) {
                        // intervals_iterations = 4
                        // intervals_minutes = 15
                        intervals_iterations = 12
                        intervals_minutes = 5
                    }

                    for (let hour = 0; hour < hours_diff * intervals_iterations; hour++) {
                        working_hours_table[val.day_name][hour_from.format("HH:mm")] = []
                        working_hours_table[val.day_name][hour_from.format("HH:mm")].push(val.modality)
                        hour_from.add(intervals_minutes, 'minutes')
                        // console.log(hour_from.format("HH:mm"))
                    }
                })

                let all_appointments = []
                for (let day of range.by('day')) {

                    let f = day.locale('es').format('YYYY-MM-DD')
                    // console.log(day.format('dd'));
                    // console.log(working_hours_table);
                    all_appointments.push({[f]: {}})
                }

                // console.log("ALL Appointments firstssss");
                // console.log(all_appointments);


                // console.log("PARAMS IN FETCH");
                // console.log(params);
                let table_data1 = { /*'09:00': 0, '09:30': 1, '10:00': 2, '10:30': 3,'11:00': 4,  '11:30': 5, '12:00': 6, '12:30': 7*/
                    '09:00': 0,
                    '09:15': 1,
                    '09:30': 2,
                    '09:45': 3,
                    '10:00': 4,
                    '10:15': 5,
                    '10:30': 6,
                    '10:45': 7,
                    '11:00': 8,
                    '11:15': 9,
                    '11:30': 10,
                    '11:45': 11,
                    '12:00': 12,
                    '12:15': 13,
                    '12:30': 14,
                    '12:45': 15,
                    '13:00': 16,
                    '13:15': 17,
                    '13:30': 18,
                    '13:45': 19,
                    '14:00': 20,
                    '14:15': 21,
                    '14:30': 22,
                    '14:45': 23,
                    '15:00': 24,
                    '15:15': 25,
                    '15:30': 26,
                    '15:45': 27,
                    '16:00': 28,
                    '16:15': 29,
                    '16:30': 30,
                    '16:45': 31,
                    '17:00': 32,
                    '17:15': 33,
                    '17:30': 34,
                    '17:45': 35,
                    '18:00': 36,
                    '18:15': 37,
                    '18:30': 38,
                    '18:45': 39,
                }
                // console.log(data);
                setLoadingList(false);
                let current_date = ""
                let all_days = []
                let day_data = undefined
                all_appointments = []
                data.results.forEach((element) => {
                    current_date = moment(element.appointment_at).format("YYYY-MM-DD")
                    const current_hour = moment(element.appointment_at).format('HH:mm')
                    let fecha = Object.keys(all_appointments).find(key => {
                        return all_appointments[key].hasOwnProperty(current_date)
                    });
                    if (!fecha) {
                        let a = {}
                        a[current_date] = {}
                        all_appointments.push(a)
                        fecha = all_appointments.length - 1
                    }
                    // console.log("********************");
                    // console.log(fecha);
                    // console.log(current_date);
                    // console.log(current_hour);
                    // console.log(all_appointments);
                    // console.log("********************");
                    // if (all_appointments[fecha][current_date][current_hour]) {
                    //   console.log(element)
                    //   all_appointments[fecha][current_date][current_hour].push(element);
                    // }
                    if (all_appointments[fecha][current_date]) {
                        // console.log(element)
                        all_appointments[fecha][current_date][current_hour] = []
                        all_appointments[fecha][current_date][current_hour].push(element.modality)
                        all_appointments[fecha][current_date][current_hour].push(element)
                    }
                })

                setAppointmentsData(all_appointments);
                // console.log("All appointmens final");
                // console.log(all_appointments);
                // ACA
            });

        }).catch((errorInfo) => {
            setLoadingList(false);
            message.error(`Ha ocurrido un error al intentar obtener los turnos.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };


    const handleExpand = () => {
        // console.log("Expand!");
        setExpand(!expand);
    }

    const onChangeFastSearch = (e) => {
        console.log(e)
    }

    const showAppointment = (e) => {
        if (isReadOnly) return;
        setAppointmentVisible(true)
        setAppointmentId(e.id)
        // console.log(e.id)
    }

    const deletePacient = (pacient = {}) => {
        //setLoadingDeleteButton(true);
        let url = "";
        let method = "";

        url = config.api_url + '/pacients/' + pacient.id + '/';
        method = 'delete';

        reqwest({
            url: url,
            method: method,
            type: 'json',
            data: pacient,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(_ => {
                //setLoadingDeleteButton(false);
                message.success("Se ha eliminado correctamente")

                form.setFieldsValue({"id": 0})
                form.setFieldsValue({pacient: ''})
                form.setFieldsValue({pacient_search: ''})
                setVisible(false)
                if (fastSearchValue) {
                    fetch({
                        pagination,
                        'filters': `&search=${fastSearchValue}`,
                    });
                } else {
                    const _filters = getFormFilters()
                    fetch({pagination, 'filters': _filters})
                }
            }
        ).catch(
            errorInfo => {
                //setLoadingSaveButton(false);
                if (errorInfo.status == 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    const error_detail_obj = JSON.parse(errorInfo.responseText);
                    let error_detail_txt = "";
                    Object.entries(error_detail_obj).forEach(([k, v]) => {
                        error_detail_txt = `${error_detail_txt}${k}\n`;
                        v.forEach((value, i, a) => {
                            error_detail_txt = `${error_detail_txt}(${value})\n`;
                        })
                        error_detail_txt = `${error_detail_txt}\n`;
                    });
                    message.error(`Ha ocurrido un error al intentar eliminar el residente.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                }
            }
        );
    };

    function onDelete() {
        deletePacient(form.getFieldsValue());
    }

    return (
        <>

            <ConfigProvider locale={esES}>
                <Layout style={{minHeight: '100vh'}}>
                    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
                        <div className="logo"/>
                        <MyMenu active={active}/>
                    </Sider>
                    <Layout className="site-layout">
                        <Header/>
                        <Content style={{margin: '0 16px'}}>
                            <Breadcrumb style={{position: "relative", margin: '16px 0'}}>
                                <Breadcrumb.Item>Home</Breadcrumb.Item>
                                <Breadcrumb.Item>Residentes</Breadcrumb.Item>
                            </Breadcrumb>
                            <div>
                                <Form
                                    form={fastSearchForm}
                                >
                                    <Form.Item
                                        name="fastSearchInput"
                                    >
                                        <Search className="site-search-button-wrapper" allowClear style={{width: '15%'}}
                                                placeholder="Búsqueda rápida" onSearch={onFastSearch}
                                                onChange={onChangeFastSearch} enterButton/>
                                    </Form.Item>
                                </Form>
                                <Button className="site-search-button-wrapper" style={{marginLeft: '1px'}}
                                        type="primary" onClick={clearFormFilters}>
                                    <MinusOutlined/> Limpiar Filtros
                                </Button>
                                <Button className="site-search-button-wrapper" style={{marginLeft: '1px'}}
                                        type="primary" onClick={showDrawerSearch}>
                                    <PlusOutlined/> Filtros
                                </Button>
                            </div>

                            <div>
                                <Button type="primary" onClick={showDrawerCreate}>
                                    <PlusOutlined/> Nuevo Residente
                                </Button>
                            </div>
                            <Drawer
                                title="Búsqueda Residente"
                                width={"40%"}
                                onClose={onCloseSearch}
                                visible={visibleSearch}
                                bodyStyle={{paddingBottom: 80}}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Button onClick={onCloseSearch} style={{marginRight: 8}}>
                                            Cancelar
                                        </Button>
                                        <Button onClick={onSearch} type="primary" loading={loadingSaveButton}>
                                            Filtrar
                                        </Button>
                                    </div>
                                }
                            >
                                <Form
                                    form={searchform}
                                    layout="vertical" hideRequiredMark
                                    initialValues={{"status": "A"}}
                                >
                                    <Row gutter={12}>
                                        {/*<Col span={6}>*/}
                                        {/*    <Form.Item*/}
                                        {/*        name="pacient_type"*/}
                                        {/*        label="Modalidad"*/}
                                        {/*        style={expand === true ? {display: "inline"} : {display: "none"}}*/}
                                        {/*    >*/}

                                        {/*        <Select*/}
                                        {/*            allowClear*/}
                                        {/*            placeholder="Tipo"*/}
                                        {/*            showArrow={false}*/}
                                        {/*        >*/}
                                        {/*            <Option value=""></Option>*/}
                                        {/*            <Option value="A">Ambulatorio</Option>*/}
                                        {/*            <Option value="D">Domicilio</Option>*/}
                                        {/*            <Option value="HM">Hosp. T. Manana</Option>*/}
                                        {/*            <Option value="HT">Hosp. T. Tarde</Option>*/}
                                        {/*            <Option value="HC">Hosp. T. Completo</Option>*/}
                                        {/*            <Option value="M1">Mic 1</Option>*/}
                                        {/*            <Option value="M2">Mic 2</Option>*/}
                                        {/*            <Option value="IN">Internación Agudo</Option>*/}
                                        {/*            <Option value="IP">Internación Prolongado</Option>*/}
                                        {/*        </Select>*/}
                                        {/*    </Form.Item>*/}
                                        {/*</Col>*/}
                                        <Col span={6}>
                                            <Form.Item
                                                name="comuna"
                                                label="Comuna"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Input placeholder="Comuna" name="comuna"/>
                                            </Form.Item>

                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Nro. Documento</Divider>
                                        <Col span={6}>
                                            <Form.Item
                                                name="document"
                                                label=""
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Input placeholder="Documento" name="document"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Estado</Divider>
                                        <Col span={6}>
                                            <Form.Item
                                                name="status"
                                                label=""
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    allowClear
                                                    showArrow={false}
                                                    defaultValue={"Activo"}
                                                    placeholder="Estado">
                                                    <Option value="A">Activo</Option>
                                                    <Option value="T">Todos</Option>
                                                    <Option value="I">Inactivo</Option>
                                                    <Option value="B">Baja</Option>
                                                    <Option value="S">Salida Temporal</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Obra Social</Divider>
                                        <Col span={4}>
                                            <Form.Item
                                                name="medical_insurance"
                                                label=""
                                            >
                                                <Select
                                                    placeholder="Por favor seleccione una obra social"
                                                    showSearch
                                                    //notFoundContent={fetchingProfesionals ? <Spin size="small" /> : null}
                                                    //onSearch={fetchProfesionals}
                                                    //onChange={handleOnChangeProfesional}
                                                    defaultActiveFirstOption={false}
                                                    //value={profesionalSelected}
                                                    allowClear
                                                    showArrow={false}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {medicalInsurances.map(d => (
                                                        <Option key={d.value} value={d.value}>{d.text}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Psicologia</Divider>
                                        <Col span={6}>
                                            <Form.Item
                                                name="psychology_treatment_modality"
                                                label="Modalidad"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    allowClear
                                                    showArrow={false}
                                                    placeholder="Mod. Psic.">
                                                    <Option value=""></Option>
                                                    <Option value="P">Presencial</Option>
                                                    <Option value="O">Online</Option>
                                                    <Option value="M">Mixta</Option>

                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item
                                                name="psychology_treatment_profesional"
                                                label="Profesional"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    placeholder="Prof. Psic."
                                                    showSearch
                                                    notFoundContent={fetchingProfesionals ? <Spin size="small"/> : null}
                                                    onSearch={fetchProfesionals}
                                                    onChange={handleOnChangeProfesional}
                                                    defaultActiveFirstOption={false}
                                                    value={profesionalSelected}
                                                    allowClear
                                                    showArrow={false}
                                                    options={profesionals}
                                                >
                                                    {profesionals.map(d => (
                                                        <Option key={d.value} value={d.value}>{d.text}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Admision</Divider>
                                        <Col span={6}>
                                            <Form.Item
                                                name="admision_treatment_modality"
                                                label="Modalidad"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    allowClear
                                                    showArrow={false}
                                                    placeholder="Mod. Psic.">
                                                    <Option value=""></Option>
                                                    <Option value="P">Presencial</Option>
                                                    <Option value="O">Online</Option>
                                                    <Option value="M">Mixta</Option>

                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item
                                                name="admision_treatment_profesional"
                                                label="Profesional"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    placeholder="Admisor"
                                                    showSearch
                                                    notFoundContent={fetchingProfesionals ? <Spin size="small"/> : null}
                                                    onSearch={fetchProfesionals}
                                                    onChange={handleOnChangeProfesional}
                                                    defaultActiveFirstOption={false}
                                                    value={profesionalSelected}
                                                    allowClear
                                                    showArrow={false}
                                                >
                                                    {profesionals.map(d => (
                                                        <Option key={d.value} value={d.value}>{d.text}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Divider orientation="left" plain>Psiquiatria</Divider>
                                        <Col span={6}>
                                            <Form.Item
                                                name="psychiatry_treatment_modality"
                                                label="Modalidad"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    allowClear
                                                    placeholder="Mod. Psiq."
                                                    showArrow={false}
                                                >
                                                    <Option value=""></Option>
                                                    <Option value="P">Presencial</Option>
                                                    <Option value="O">Online</Option>
                                                    <Option value="M">Mixta</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item
                                                name="psychiatry_treatment_profesional"
                                                label="Profesional"
                                                style={expand === true ? {display: "inline"} : {display: "none"}}
                                            >
                                                <Select
                                                    placeholder="Prof. Psiq."
                                                    showSearch
                                                    notFoundContent={fetchingProfesionals ? <Spin size="small"/> : null}
                                                    onSearch={fetchProfesionals}
                                                    onChange={handleOnChangeProfesional}
                                                    defaultActiveFirstOption={false}
                                                    value={profesionalSelected}
                                                    allowClear
                                                    showArrow={false}
                                                >
                                                    {
                                                        profesionals.map(d => (

                                                            <Option key={d.value} value={d.value}>{d.text}</Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {/*<Search className="site-search-button-wrapper" allowClear style={{ width: '15%'}} placeholder="" onSearch={onSearch} enterButton />
                    <Button className="site-search-button-wrapper" onClick={handleExpand}>Busqueda avanzada</Button>*/}
                                    </Row>
                                </Form>
                            </Drawer>
                            <Drawer
                                title="Nuevo Turno"
                                width={"60%"}
                                onClose={onCloseAppointment}
                                visible={visibleAppointment}
                                bodyStyle={{paddingBottom: 80}}
                                /*footer={
                  <div
                    style={{
                      textAlign: 'right',
                    }}
                  >
                    <Button onClick={onCloseAppointment} style={{ marginRight: 8 }}>
                      Cancelar
                    </Button>
                    <Button onClick={onSearchAppointment} type="primary" loading={loadingSaveButton}>
                      Filtrar
                    </Button>
                  </div>
                }*/
                            >
                                <Form
                                    form={appointmentform}
                                    layout="vertical" hideRequiredMark
                                >
                                    <Row gutter={24}>
                                        <Col span={3}>
                                            <Form.Item
                                                name="appointment_range"
                                                label="Fecha Inicio"
                                            >
                                                <DatePicker defaultValue={moment()}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item
                                                name="appointment_days"
                                                label="Dentro de"
                                            >
                                                <InputNumber
                                                    min={0}
                                                    max={90}
                                                    formatter={value => `${value} dias`}
                                                    parser={value => value.replace('dias', '')}
                                                    defaultValue={0}/>
                                            </Form.Item>
                                        </Col>
                                        {/*<Col span={12}>
                      <Form.Item
                          name="motive"
                          label=" "
                      >
                      <Select>
                          <Option value="CA">Consulta</Option>
                          <Option value="AD">Admision</Option>
                          <Option value="RA">Readmision</Option>
                      </Select>
                    </Form.Item>
                    </Col>*/}
                                        <Col span={12}>
                                            <Form.Item
                                                name=""
                                                label=" "
                                            >
                                                <Radio.Group>
                                                    <Radio.Button onClick={() => onSearchAppointment('previous')}
                                                                  type="primary"
                                                                  loading={loadingSaveButton}>Anterior</Radio.Button>
                                                    <Radio.Button onClick={onSearchAppointment} type="primary"
                                                                  loading={loadingSaveButton}>Filtrar</Radio.Button>
                                                    <Radio.Button onClick={() => onSearchAppointment('next')}
                                                                  loading={loadingSaveButton}>Siguiente</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {/*<Col span={4}>
                    <Form.Item
                        name="appointment_days_before"
                        label="Mostrar"
                    >
                      <InputNumber
                       style={{ width: '75%' }}
                       min={0}
                       max={90}
                       formatter={value => `${value} dias antes`}
                       parser={value => value.replace('dias antes', '')}
                       defaultValue={0} />
                    </Form.Item>
                    </Col>
                    <Col span={4}>
                    <Form.Item
                        name="appointment_days_after"
                        label=" "
                    >
                      <InputNumber
                       style={{ width: '75%'}}
                       min={0}
                       max={90}
                       formatter={value => `${value} dias desps`}
                       parser={value => value.replace('dias desps', '')}
                       defaultValue={0} />
                    </Form.Item>
                    </Col>*/}
                                    </Row>
                                </Form>
                                {
                                    (slotsTaken.length > 0 && <Divider orientation="left">Turnos tomados</Divider>)
                                }
                                {
                                    slotsTaken.map((key, value) => {
                                        // console.log("Turno tomado");
                                        // console.log(key);
                                        let color = "blue"
                                        if (key.modality == 'O') {
                                            color = "purple"
                                        }

                                        return <Tag
                                            style={{cursor: "pointer"}}
                                            closable={true}
                                            onClose={() => handleDeleteAppointment(key.id, value)}
                                            color={color}> {moment(key.appointment_at).format('DD-MM-YYYY HH:mm')} ({key.modality} - {key.motive})
                                        </Tag>
                                    })
                                }
                                <Divider orientation="left">Turnos Disponibles</Divider>
                                <List
                                    loading={loadingList}
                                    dataSource={appointmentsData}
                                    renderItem={item => (
                                        <List.Item>
                                            {moment(Object.keys(item)[0]).format('ddd DD MMMM')}
                                            <br/>
                                            <br/>
                                            {
                                                Object.keys(item).map((key) => {
                                                    // console.log(key, item[key])
                                                    moment(key).format('dd')

                                                    if (item[key]) {
                                                        // console.log("Dentro")
                                                        // console.log(key);
                                                        let a = Object.keys(item[key]).map((k, idx) => {
                                                            // console.log("dentro!!")
                                                            // console.log(k,item[key][k])
                                                            if (item[key][k].length === 2 && !item[key][k][1]['id']) {
                                                                if (item[key][k][1]['motive'] != 'SE') {
                                                                    if (item[key][k][0] === 'M' || item[key][k][0] === 'P') {
                                                                        return (
                                                                            <>
                                                                                <Tag
                                                                                    style={{cursor: "pointer"}}
                                                                                    size={"small"}
                                                                                    onClick={() => handleNewAppointment(Object.keys(item), k, "O", appointmentform.getFieldValue("motive"))}
                                                                                    color={"purple"}
                                                                                >{k} (O)
                                                                                </Tag>
                                                                                <Tag
                                                                                    style={{cursor: "pointer"}}
                                                                                    size={"small"}
                                                                                    onClick={() => handleNewAppointment(Object.keys(item), k, "P", appointmentform.getFieldValue("motive"))}
                                                                                    color={"blue"}
                                                                                >{k} (P)
                                                                                </Tag>
                                                                            </>
                                                                        )
                                                                    } else {

                                                                        return (
                                                                            <>
                                                                                <Tag
                                                                                    style={{cursor: "pointer"}}
                                                                                    size={"small"}
                                                                                    onClick={() => handleNewAppointment(Object.keys(item), k, "O", appointmentform.getFieldValue("motive"))}
                                                                                    color={"purple"}
                                                                                >{k} (O)
                                                                                </Tag>
                                                                            </>
                                                                        )

                                                                    }
                                                                }
                                                            }
                                                            return []
                                                        })
                                                        return a
                                                        /*Object.keys(item[key]).forEach((k) => {
                              // console.log(k,item[key][k])
                              if (item[key][k]){
                                return <Tag
                                style={ {cursor: "pointer"}}
                                size={"small"}
                                //onClick={() => handleNewAppointment(Object.keys(item), key.appointment_at)}
                                //color={color}
                                 >{item[key][k]}
                              </Tag>
                              }
                            })*/
                                                    }

                                                })
                                                /*item[Object.keys(item)[0]].map( (key, value) => {
                          if (key.appointments.length === 0){
                          let color = "blue"
                           return <Tag
                                    style={ {cursor: "pointer"}}
                                    size={"small"}
                                    onClick={() => handleNewAppointment(Object.keys(item), key.appointment_at)}
                                    color={color}
                                     >{key.appointment_at}
                                  </Tag>
                          }
                          return ""
                        })
                      */}
                                        </List.Item>
                                    )}
                                >
                                </List>

                            </Drawer>
                            <Table
                                showSizeChanger
                                columns={columns}
                                rowKey={record => record.id}
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            showDrawer(record.id)
                                        }, // click row
                                        //onDoubleClick: event => {}, // double click row
                                        //onContextMenu: event => {}, // right button click row
                                        //onMouseEnter: event => {}, // mouse enter row/
                                        //onMouseLeave: event => {}, // mouse leave row
                                    };
                                }}
                                dataSource={data}
                                pagination={pagination}
                                loading={loading}
                                onChange={handleTableChange}
                            />
                            <Drawer
                                title="Residente"
                                width={"65%"}
                                onClose={onClose}
                                visible={visible}
                                bodyStyle={{paddingBottom: 80}}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Popconfirm
                                            title="¿Está seguro que desea eliminar este residente?"
                                            onConfirm={onDelete}
                                            okText="Sí, eliminar"
                                            cancelText="Cancelar"
                                            okButtonProps={{danger: true}}
                                        >
                                            <Button type={"danger"} style={deleteVisible ? {
                                                display: "inline",
                                                marginRight: 8
                                            } : {display: "none"}}>
                                                Eliminar
                                            </Button>
                                        </Popconfirm>
                                        <Button onClick={onClose} style={{marginRight: 8}}>
                                            Cancelar
                                        </Button>
                                        <Button onClick={onSave} type="primary" loading={loadingSaveButton}>
                                            Guardar
                                        </Button>
                                    </div>
                                }
                            >
                                <Spin spinning={spinning}>
                                    <Form
                                        form={form}
                                        layout="vertical" hideRequiredMark
                                    >
                                        <Tabs activeKey={activeTab} onTabClick={(value) => {
                                            // console.log("Click en tab")
                                            // console.log(value)
                                            setActiveTab(value)
                                            if (value === "3") {
                                                if (form.getFieldValue('id') > 0) {
                                                    fetchPacientAppointments(form.getFieldValue("id"), {'pagination': pacientAppointmentPagination})
                                                } else {
                                                    setPacientAppointments([])
                                                }

                                            }
                                        }}>
                                            <TabPane tab="Datos Personales" key="1">
                                                <Row gutter={16}>
                                                    <Col span={18}>
                                                        <Row gutter={4}>
                                                            <Col span={6}>
                                                                <Form.Item>
                                                                    <div style={{marginBottom: 8}}>
                                                                        {photoUrl ? (
                                                                            <div style={{
                                                                                position: 'relative',
                                                                                display: 'inline-block'
                                                                            }}>
                                                                                <Avatar
                                                                                    shape="square"
                                                                                    size={120}
                                                                                    src={photoUrl.startsWith('http') || photoUrl.startsWith('blob:') ? photoUrl : `${config.api_url.replace('/api', '')}${photoUrl.startsWith('/') ? '' : '/'}${photoUrl}`}
                                                                                    icon={<UserOutlined/>}
                                                                                    style={{objectFit: 'cover'}}
                                                                                />
                                                                                {isUploading && (
                                                                                    <div style={{
                                                                                        position: 'absolute',
                                                                                        top: 0,
                                                                                        left: 0,
                                                                                        width: '100%',
                                                                                        height: '100%',
                                                                                        background: 'rgba(255, 255, 255, 0.7)',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>
                                                                                        <Progress type="circle"
                                                                                                  percent={uploadProgress}
                                                                                                  width={80}/>
                                                                                    </div>
                                                                                )}
                                                                                {!isUploading && (
                                                                                    <Button
                                                                                        type="primary"
                                                                                        danger
                                                                                        shape="circle"
                                                                                        icon={<DeleteOutlined/>}
                                                                                        size="small"
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: -10,
                                                                                            right: -10
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setPhotoUrl(null);
                                                                                            setFileList([]);
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <div style={{
                                                                                position: 'relative',
                                                                                display: 'inline-block'
                                                                            }}>
                                                                                <Avatar shape="square" size={120}
                                                                                        icon={<UserOutlined/>}/>
                                                                                {isUploading && (
                                                                                    <div style={{
                                                                                        position: 'absolute',
                                                                                        top: 0,
                                                                                        left: 0,
                                                                                        width: '100%',
                                                                                        height: '100%',
                                                                                        background: 'rgba(255, 255, 255, 0.7)',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>
                                                                                        <Progress type="circle"
                                                                                                  percent={uploadProgress}
                                                                                                  width={80}/>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <Upload
                                                                        accept=".jpg,.jpeg,.webp"
                                                                        beforeUpload={async (file) => {
                                                                            try {
                                                                                const compressed = await compressImage(file);
                                                                                setFileList([compressed]);
                                                                                setPhotoUrl(URL.createObjectURL(compressed));
                                                                            } catch (err) {
                                                                                message.error("Error al procesar la imagen");
                                                                            }
                                                                            return false; // Prevent auto-upload
                                                                        }}
                                                                        fileList={fileList}
                                                                        showUploadList={false}
                                                                    >
                                                                        <Button icon={<UploadOutlined/>}>Subir
                                                                            Foto</Button>
                                                                    </Upload>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>

                                                        <Row gutter={12}>
                                                            {/*<Col span={6}>*/}
                                                            {/*    <Form.Item*/}
                                                            {/*        name="pacient_type"*/}
                                                            {/*        label="Modalidad"*/}
                                                            {/*        rules={[{*/}
                                                            {/*            required: true,*/}
                                                            {/*            message: 'Por favor seleccione una modalidad'*/}
                                                            {/*        }]}*/}
                                                            {/*    >*/}
                                                            {/*        <Select*/}
                                                            {/*            placeholder="Por favor seleccione una modalidad"*/}
                                                            {/*            defaultValue={formData.pacient_type}>*/}
                                                            {/*            <Option value="A">Ambulatorio</Option>*/}
                                                            {/*            <Option value="D">Domicilio</Option>*/}
                                                            {/*            <Option value="HM">Hosp. T. Manana</Option>*/}
                                                            {/*            <Option value="HT">Hosp. T. Tarde</Option>*/}
                                                            {/*            <Option value="HC">Hosp. T. Completo</Option>*/}
                                                            {/*            <Option value="M1">Mic 1</Option>*/}
                                                            {/*            <Option value="M2">Mic 2</Option>*/}
                                                            {/*            <Option value="IN">Internación Agudo</Option>*/}
                                                            {/*            <Option value="IP">Internación*/}
                                                            {/*                Prolongado</Option>*/}
                                                            {/*        </Select>*/}
                                                            {/*    </Form.Item>*/}
                                                            {/*</Col>*/}
                                                            <Col span={6}>
                                                                <Form.Item
                                                                    name="status"
                                                                    label="Estado"
                                                                    rules={[{
                                                                        required: true,
                                                                        message: 'Por favor seleccione un estado'
                                                                    }]}
                                                                >
                                                                    <Select
                                                                        onChange={onStatuChange}
                                                                        placeholder="Por favor seleccione un estado"
                                                                        defaultValue={formData.status}>
                                                                        <Option value="A">Activo</Option>
                                                                        <Option value="I">Inactivo</Option>
                                                                        <Option value="B">Baja</Option>
                                                                        <Option value="S">Salida Temporal</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            {/*<Col span={6}>*/}
                                                            {/*    <Form.Item*/}
                                                            {/*        name="copago"*/}
                                                            {/*        label="Copago"*/}
                                                            {/*        rules={[{*/}
                                                            {/*            required: true,*/}
                                                            {/*            message: 'Por favor seleccione copago'*/}
                                                            {/*        }]}*/}
                                                            {/*    >*/}
                                                            {/*        <Select*/}
                                                            {/*            placeholder="Por favor seleccione una opción"*/}
                                                            {/*            defaultValue={formData.copago}>*/}
                                                            {/*            <Option value="N">No</Option>*/}
                                                            {/*            <Option value="Y">Si</Option>*/}
                                                            {/*        </Select>*/}
                                                            {/*    </Form.Item>*/}
                                                            {/*</Col>*/}
                                                            <Col span={6}>
                                                                <Form.Item
                                                                    name="destroyed_cause"
                                                                    label="Motivo de baja"
                                                                    style={showDestroyedFields === true ? {display: "inline"} : {display: "none"}}
                                                                    rules={[
                                                                        {
                                                                            validator: async (_, destroyed_cause) => {
                                                                                if (showDestroyedFields && !destroyed_cause) {
                                                                                    return Promise.reject(new Error('Seleccione un motivo'));
                                                                                }
                                                                            },
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder="Por favor seleccione un motivo"
                                                                        defaultValue={formData.destroyed_cause}>
                                                                        <Option value=""></Option>
                                                                        <Option value="OB">Obito</Option>
                                                                        <Option value="A">Abandono</Option>
                                                                        <Option value="NA">No asistio nunca</Option>
                                                                        <Option value="O">Otro</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Datos Personales</Divider>
                                                <Row gutter={16}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="name"
                                                            label="Nombre"
                                                            initialValue={formData.name}
                                                            rules={[{required: true, message: 'Ingrese un nombre'}]}
                                                        >
                                                            <Input placeholder="Ingrese un nombre"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="id"
                                                            label="id"
                                                            hidden
                                                        >
                                                            <Input hidden defaultValue={formData.id}/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            name="last_name"
                                                            label="Apellido"
                                                            rules={[{required: true, message: 'Ingrese un apellido'}]}
                                                        >
                                                            <Input placeholder="Ingrese un apellido"
                                                                   defaultValue={formData.last_name}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="document_type"
                                                            label="Tipo de Documento"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione un tipo de documento'
                                                            }]}
                                                        >
                                                            <Select
                                                                placeholder="Por favor seleccione un tipo de documento"
                                                                defaultValue={formData.document_type}>
                                                                <Option value="DNI">DNI</Option>
                                                                <Option value="LC">LC</Option>
                                                                <Option value="LE">LE</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="document"
                                                            label="Documento"
                                                            rules={[{required: true, message: 'Ingrese un documento'}]}
                                                        >
                                                            <Input placeholder="Ingrese un documento"
                                                                   defaultValue={formData.document}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="gender"
                                                            label="Genero"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione un genero'
                                                            }]}
                                                        >
                                                            <Select placeholder="Por favor seleccione un genero"
                                                                    defaultValue={formData.gender}>
                                                                <Option value="M">Masculino</Option>
                                                                <Option value="F">Femenino</Option>
                                                                <Option value="O">Otro</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="birth_date"
                                                            label="Fecha de Nacimiento"
                                                            rules={[]}
                                                        >
                                                            <DatePicker style={{width: '100%'}} format={'YYYY-MM-DD'}
                                                                        onChange={(value) => {
                                                                            if (value) {
                                                                                // compute age
                                                                                const today = moment();
                                                                                let years = today.diff(value, 'years');
                                                                                // Adjust if needed (moment.diff in years is fine)
                                                                                form.setFieldsValue({age: years});
                                                                            } else {
                                                                                form.setFieldsValue({age: null});
                                                                            }
                                                                        }}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="age"
                                                            label="Edad"
                                                        >
                                                            <Input placeholder="" readOnly/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Contacto</Divider>
                                                <Row gutter={15}>
                                                    <Col span={5}>
                                                        <Form.Item
                                                            name="contact"
                                                            label="Contacto"
                                                            initialValue={formData.contact}
                                                            //rules={[{ required: true, message: 'Ingrese un contact' }]}
                                                        >
                                                            <Input placeholder="Ingrese un contacto"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={5}>
                                                        <Form.Item
                                                            name="email"
                                                            label="Email"
                                                            rules={[{
                                                                type: 'email',
                                                                message: 'Ingrese un email valido',
                                                            },
                                                                //{ required: true, message: 'Ingrese un email' }
                                                            ]}
                                                        >
                                                            <Input placeholder="Ingrese un email"
                                                                   defaultValue={formData.email}/>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="phone"
                                                            label="Tel. principal"
                                                            rules={[{required: true, message: 'Ingrese un telefono'}]}
                                                        >
                                                            <Input placeholder="Ingrese un telefono"
                                                                   defaultValue={formData.phone}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="alternative_phone_1"
                                                            label="Tel. alt. 1"
                                                            initialValue={formData.alternative_phone_1}
                                                        >
                                                            <Input
                                                                placeholder="Ingrese un primer telefono alternativo"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="alternative_phone_2"
                                                            label="Tel. alt. 2"
                                                            initialValue={formData.alternative_phone_2}
                                                        >
                                                            <Input
                                                                placeholder="Ingrese un segundo telefono alternativo"/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Datos Obra Social</Divider>
                                                <Row gutter={12}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="medical_insurance"
                                                            label="Obra Social"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione una obra social'
                                                            }]}
                                                        >
                                                            <Select
                                                                placeholder="Por favor seleccione una obra social"
                                                                showSearch
                                                                //notFoundContent={fetchingProfesionals ? <Spin size="small" /> : null}
                                                                //onSearch={fetchProfesionals}
                                                                //onChange={handleOnChangeProfesional}
                                                                defaultActiveFirstOption={false}
                                                                //value={profesionalSelected}
                                                                allowClear
                                                                showArrow={false}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {medicalInsurances.map(d => (
                                                                    <Option key={d.value}
                                                                            value={d.value}>{d.text}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="medical_plan"
                                                            label="Plan"
                                                            initialValue={formData.medical_plan}
                                                        >
                                                            <Input placeholder="Ingrese un plan"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="medical_id"
                                                            label="Nro de afiliado"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Ingrese el nro de afiliado'
                                                            }]}
                                                        >
                                                            <Input placeholder="Ingrese el nro de afiliado"
                                                                   defaultValue={formData.medial_id}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {/*<Divider orientation="left">Domicilio</Divider>*/}
                                                {/*<Row>*/}
                                                {/*    <Col span={24}>*/}
                                                {/*        <Checkbox checked={useMap} onChange={(e) => {*/}
                                                {/*            const checked = e.target.checked;*/}
                                                {/*            setUseMap(checked);*/}
                                                {/*            if (checked) {*/}
                                                {/*                showChildrenDrawer();*/}
                                                {/*            } else {*/}
                                                {/*                onChildrenDrawerClose();*/}
                                                {/*            }*/}
                                                {/*        }}>Geolocalizar con mapa</Checkbox>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}
                                                {/*<Row gutter={12}>*/}
                                                {/*    <Col span={10}>*/}
                                                {/*        <Form.Item*/}
                                                {/*            name="address"*/}
                                                {/*            label="Domicilio"*/}
                                                {/*            initialValue={formData.address}*/}
                                                {/*            //rules={[{ required: true, message: 'Ingrese una calle' }]}*/}
                                                {/*        >*/}
                                                {/*            <Input placeholder="Ingrese un calle"*/}
                                                {/*                   onFocus={useMap ? showChildrenDrawer : undefined}*/}
                                                {/*                   readOnly={useMap}/>*/}
                                                {/*        </Form.Item>*/}
                                                {/*    </Col>*/}
                                                {/*    <Col span={3}>*/}
                                                {/*        <Form.Item*/}
                                                {/*            name="floor"*/}
                                                {/*            label="Piso y dto"*/}
                                                {/*        >*/}
                                                {/*            <Input placeholder="ej. 1 A" defaultValue={formData.floor}/>*/}
                                                {/*        </Form.Item>*/}
                                                {/*    </Col>*/}
                                                {/*    <Col span={3}>*/}
                                                {/*        <Form.Item*/}
                                                {/*            name="comuna"*/}
                                                {/*            label="Comuna"*/}
                                                {/*        >*/}
                                                {/*            <Input defaultValue={formData.comuna} readOnly={useMap}/>*/}
                                                {/*        </Form.Item>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}
                                                <Row gutter={12}>
                                                    <Col span={12}>
                                                        <Form.Item
                                                            name="notes"
                                                            label="Notas"
                                                            initialValue={formData.notes}
                                                        >
                                                            <Input.TextArea placeholder=""/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tab="Tratamientos" key="2">
                                                <div style={isReadOnly ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
                                                    <Divider orientation="left" plain>Psicologia</Divider>
                                                <Row gutter={16}>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychology_treatment_status"
                                                            label="Estado"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione un estado'
                                                            }]}
                                                        >
                                                            <Select
                                                                onChange={onPsychologyStatusChange}
                                                                placeholder="Por favor seleccione un estado"
                                                            >
                                                                <Option value="NA">-</Option>
                                                                <Option value="A">Activo</Option>
                                                                <Option value="I">Inactivo</Option>
                                                                <Option value="AB">Abandono</Option>
                                                                <Option value="S">Salida Temporal</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="total_psychology_sessions"
                                                            label="Sesiones Totales"
                                                            initialValue={formData.total_psychology_sessions}
                                                            style={showPsychologyFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychologyFields && !values) {
                                                                            return Promise.reject(new Error('Ingrese un total de sesiones'));
                                                                        }
                                                                    },
                                                                },
                                                                {
                                                                    validator: async (_, value) => {
                                                                        if (form.getFieldValue('current_psychology_sessions') > value) {
                                                                            return Promise.reject(new Error('La cantidad total de sesiones no puede ser menor que las actuales'));
                                                                        }
                                                                    },
                                                                },

                                                            ]}
                                                        >
                                                            <Input placeholder="Ingrese la cantidad total de sesiones"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="current_psychology_sessions"
                                                            label="Sesiones Actuales"
                                                            initialValue={formData.current_psychology_sessions}
                                                            style={showPsychologyFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychologyFields && !values) {
                                                                            return Promise.reject(new Error('Ingrese las sesiones actuales'));
                                                                        }
                                                                    },
                                                                },
                                                                {
                                                                    validator: async (_, value) => {
                                                                        if (form.getFieldValue('total_psychology_sessions') < value) {
                                                                            return Promise.reject(new Error('La cantidad de sesiones actual no puede ser mayor que el total'));
                                                                        }
                                                                    },
                                                                },

                                                            ]}

                                                        >
                                                            <Input
                                                                placeholder="Ingrese la cantidad actual de sesiones"/>
                                                        </Form.Item>
                                                    </Col>
                                                    {/*<Col span={3}>*/}
                                                    {/*    <Form.Item*/}
                                                    {/*        name="psychology_treatment_modality"*/}
                                                    {/*        label="Modalidad"*/}
                                                    {/*        style={showPsychologyFields === true ? {display: "inline"} : {display: "none"}}*/}
                                                    {/*    >*/}
                                                    {/*        <Select placeholder="Por favor seleccione una modalidad"*/}
                                                    {/*                defaultValue={formData.psychology_treatment_modality}>*/}
                                                    {/*            <Option value="P">Presencial</Option>*/}
                                                    {/*            <Option value="O">Online</Option>*/}
                                                    {/*            <Option value="M">Mixta</Option>*/}
                                                    {/*        </Select>*/}
                                                    {/*    </Form.Item>*/}
                                                    {/*</Col>*/}
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychology_treatment_frequency"
                                                            label="Frecuencia"
                                                            style={showPsychologyFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychologyFields && !values) {
                                                                            return Promise.reject(new Error('Selecciones una frecuencia'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Select placeholder="Por favor seleccione una frecuencia"
                                                                    defaultValue={formData.psychology_treatment_frequency}>
                                                                <Option value=""></Option>
                                                                <Option value="S">Semanal</Option>
                                                                <Option value="M">Mensual</Option>
                                                                <Option value="B">Bimenstral</Option>
                                                                <Option value="T">Trimenstral</Option>
                                                                <Option value="SME">Semestral</Option>
                                                                <Option value="O">Otra</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychology_treatment_profesional"
                                                            label="Profesional"
                                                            style={showPsychologyFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychologyFields && !values) {
                                                                            return Promise.reject(new Error('Seleccione el profesional'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}

                                                        >
                                                            <Select
                                                                placeholder="Por favor seleccione un profesional"
                                                                showSearch
                                                                //notFoundContent={fetchingProfesionals ? <Spin size="small" /> : null}
                                                                //onSearch={fetchProfesionals}
                                                                onChange={handleOnChangeProfesional}
                                                                defaultActiveFirstOption={false}
                                                                value={profesionalSelected}
                                                                allowClear
                                                                showArrow={false}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {profesionals.map(d => (
                                                                    <Option key={d.value}
                                                                            value={d.value}>{d.text}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    {/*<Col span={2}>
                      {<Form.Item
                      label=" "
                      style={ showPsychologyFields === true ? {display: "inline"} : {display: "none"} }
                    >
                      <Button type="primary" onClick={() => showDrawerAppointment("psychology_treatment_profesional")}>Turno Psicologia</Button>
                    </Form.Item>
                    </Col>*/}
                                                </Row>

                                                <Divider orientation="left" plain>Psiquiatria</Divider>
                                                <Row gutter={16}>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychiatry_treatment_status"
                                                            label="Estado"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione un estado'
                                                            }]}
                                                        >
                                                            <Select
                                                                onChange={onPsychiatryStatusChange}
                                                                placeholder="Por favor seleccione un estado"
                                                            >
                                                                <Option value="NA">-</Option>
                                                                <Option value="A">Activo</Option>
                                                                <Option value="I">Inactivo</Option>
                                                                <Option value="AB">Abandono</Option>
                                                                <Option value="S">Salida Temporal</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="total_psychiatry_sessions"
                                                            label="Sesiones Totales"
                                                            initialValue={formData.total_psychiatry_sessions}
                                                            style={showPsychiatryFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychiatryFields && !values) {
                                                                            return Promise.reject(new Error('Ingrese las sesiones totales'));
                                                                        }
                                                                    },
                                                                },
                                                                {
                                                                    validator: async (_, value) => {
                                                                        if (form.getFieldValue('current_psychiatry_sessions') > value) {
                                                                            return Promise.reject(new Error('La cantidad total de sesiones no puede ser menor que las actuales'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input placeholder="Ingrese la cantidad total de sesiones"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="current_psychiatry_sessions"
                                                            label="Sesiones Actuales"
                                                            initialValue={formData.current_psychiatry_sessions}
                                                            style={showPsychiatryFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychiatryFields && !values) {
                                                                            return Promise.reject(new Error('Ingrese las sesiones actuales'));
                                                                        }
                                                                    },
                                                                },
                                                                {
                                                                    validator: async (_, value) => {
                                                                        if (form.getFieldValue('total_psychiatry_sessions') < value) {
                                                                            return Promise.reject(new Error('La cantidad de sesiones actuales no puede ser mayor que el total'));
                                                                        }
                                                                    },
                                                                },

                                                            ]}

                                                        >
                                                            <Input
                                                                placeholder="Ingrese la cantidad actual de sesiones"/>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychiatry_treatment_modality"
                                                            label="Modalidad"
                                                            style={showPsychiatryFields === true ? {display: "inline"} : {display: "none"}}
                                                        >
                                                            <Select placeholder="Por favor seleccione una modalidad"
                                                                    defaultValue={formData.psychiatry_treatment_modality}>
                                                                <Option value="P">Presencial</Option>
                                                                <Option value="O">Online</Option>
                                                                <Option value="M">Mixta</Option>

                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychiatry_treatment_frequency"
                                                            label="Frecuencia"
                                                            style={showPsychiatryFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychiatryFields && !values) {
                                                                            return Promise.reject(new Error('Seleccione la frecuencia'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}

                                                        >
                                                            <Select placeholder="Por favor seleccione una frecuencia"
                                                                    defaultValue={formData.psychiatry_treatment_frequency}>
                                                                <Option value=""></Option>
                                                                <Option value="S">Semanal</Option>
                                                                <Option value="M">Mensual</Option>
                                                                <Option value="B">Bimenstral</Option>
                                                                <Option value="T">Trimenstral</Option>
                                                                <Option value="SME">Semestral</Option>
                                                                <Option value="O">Otra</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="psychiatry_treatment_profesional"
                                                            label="Profesional"
                                                            style={showPsychiatryFields === true ? {display: "inline"} : {display: "none"}}
                                                            rules={[
                                                                {
                                                                    validator: async (_, values) => {
                                                                        if (showPsychiatryFields && !values) {
                                                                            return Promise.reject(new Error('Seleccione el profesional'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}

                                                        >
                                                            <Select
                                                                placeholder="Por favor seleccione un profesional"
                                                                showSearch
                                                                //notFoundContent={fetchingProfesionals ? <Spin size="small" /> : null}
                                                                //onSearch={fetchProfesionals}
                                                                onChange={handleOnChangeProfesional}
                                                                defaultActiveFirstOption={false}
                                                                value={profesionalSelected}
                                                                allowClear
                                                                showArrow={false}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {profesionals.map(d => (
                                                                    <Option key={d.value}
                                                                            value={d.value}>{d.text}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    {/*<Col span={2}>
                    <Form.Item
                      label=" "
                      style={  showPsychiatryFields === true ? {display: "inline"} : {display: "none"} }
                    >
                      <Button type="primary" onClick={() => showDrawerAppointment("psychiatry_treatment_profesional")}>Turno Psiquiatria</Button>
                    </Form.Item>
                    </Col>*/}
                                                </Row>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="Turnos" key="3">
                                                <div
                                                    style={{
                                                        textAlign: 'left',
                                                        padding: 2,
                                                        marginBottom: '10px',
                                                        display: isReadOnly ? 'none' : 'block'
                                                    }}
                                                >
                                                    <Button type="primary"
                                                            onClick={() => showDrawerAppointment("psychology_treatment_profesional")}>+
                                                        Nuevo Turno Psicologia</Button>
                                                    <Button type="primary"
                                                            onClick={() => showDrawerAppointment("psychiatry_treatment_profesional")}>+
                                                        Nuevo Turno Psiquiatria</Button>
                                                    <Button type="primary"
                                                            onClick={() => showDrawerAppointment("admision")}>+ Nuevo
                                                        Turno Admision</Button>
                                                </div>
                                                <Table
                                                    size="small"
                                                    showSizeChanger
                                                    rowKey={record => record.id}
                                                    onRow={(record, rowIndex) => {
                                                        let id = ""
                                                        // console.log(record);
                                                        return {
                                                            onClick: event => {
                                                                if (!isReadOnly) {
                                                                    showAppointment(record)
                                                                }
                                                            },
                                                        }
                                                    }}
                                                    // onRow={(record, rowIndex) => {
                                                    //   /*// console.log("El record");
                                                    //   // console.log(record);*/
                                                    //
                                                    //   //let id = ""
                                                    //   //if (record.appointments.length > 0){
                                                    //   //    id = record.appointments[0].id
                                                    //   //}
                                                    //
                                                    //   //return {
                                                    //   //  onClick: event => { showDrawer(id)}, // click row
                                                    //     //onDoubleClick: event => {}, // double click row
                                                    //     //onContextMenu: event => {}, // right button click row
                                                    //     //onMouseEnter: event => {}, // mouse enter row/
                                                    //     //onMouseLeave: event => {}, // mouse leave row
                                                    //   //};
                                                    //   return
                                                    // }}
                                                    dataSource={pacientAppointments}
                                                    pagination={pacientAppointmentPagination}
                                                    onChange={handlePacientAppointmentsTableChange}

                                                    //loading={loading}
                                                    //onChange={handleTableChange}
                                                >
                                                    <Col
                                                        title="Hora"
                                                        render={(text, record, index) => {
                                                            return `${moment(record.appointment_at).format('DD-MM-YYYY HH:mm')}`
                                                        }
                                                        }
                                                    />
                                                    <Col
                                                        title="Tipo de atencion"
                                                        dataIndex="modality"
                                                    />
                                                    <Col
                                                        title="Profesional"
                                                        render={(text, record, index) => {
                                                            return `${record.profesional_name} ${record.profesional_last_name}`
                                                        }
                                                        }
                                                    />
                                                    <Col
                                                        title="Asistio"
                                                        render={(text, record, index) => {
                                                            if (record.present === 'NA') {
                                                                return `-`
                                                            }
                                                            if (record.present === 'A') {
                                                                return `No`
                                                            }
                                                            if (record.present === 'P') {
                                                                return `Si`
                                                            }
                                                            if (record.present === 'AA') {
                                                                return `No c/aviso`
                                                            }
                                                        }}
                                                    />
                                                    <Col
                                                        title="Atendido"
                                                        render={(text, record, index) => {
                                                            if (record.attended === 'NA') {
                                                                return `-`
                                                            }
                                                            if (record.attended === 'N') {
                                                                return `No`
                                                            }
                                                            if (record.attended === 'Y') {
                                                                return `Si`
                                                            }
                                                        }
                                                        }
                                                    />
                                                    <Col
                                                        title="Motivo"
                                                        dataIndex="motive"
                                                    />
                                                    <Col
                                                        title="Debe"
                                                        dataIndex="debt_amount"
                                                    />
                                                    <Col
                                                        title="Met. Pago"
                                                        dataIndex="payment_method"
                                                    />

                                                </Table>
                                                <Appointment key={appointmentId}
                                                             setAppointmentVisible={setAppointmentVisible}
                                                             visible={appointmentVisible}
                                                             appointment_id={appointmentId}
                                                             refresh_callback={fetchPacientAppointments}
                                                             pagination={pagination}
                                                />
                                            </TabPane>
                                            <TabPane tab="Hist. Clínica"
                                                // disabled={tabsDisabled}
                                                     key="4">
                                                <PatientProgress key={form.getFieldValue('id')}
                                                                 patient_id={form.getFieldValue('id')}
                                                />
                                            </TabPane>
                                            {/*<TabPane tab="Hist. Tipo Paciente"*/}
                                            {/*    // disabled={tabsDisabled}*/}
                                            {/*         key="5">*/}
                                            {/*    <PatientTypeHistory key={form.getFieldValue('id')}*/}
                                            {/*                        patient_id={form.getFieldValue('id')}*/}
                                            {/*    />*/}
                                            {/*</TabPane>*/}
                                        </Tabs>
                                    </Form>
                                </Spin>
                                <Drawer
                                    title="Domicilio"
                                    width={640}
                                    closable={false}
                                    onClose={onChildrenDrawerClose}
                                    visible={childrenDrawer}
                                    footer={
                                        <div
                                            style={{
                                                textAlign: 'right',
                                            }}
                                        >
                                            <Button style={{textAlign: "right", marginRight: 8, marginTop: "16px"}}
                                                    onClick={onChildrenDrawerClose}>Cancelar</Button>
                                            <Button style={{textAlign: "right", marginRight: 8, marginTop: "16px"}}
                                                    type="primary" disabled={disabled}
                                                    onClick={onConfirmAddress}>Confirmar</Button>
                                        </div>
                                    }

                                >
                                    <LoadScript
                                        libraries={["places"]}
                                        googleMapsApiKey='AIzaSyBExBf4ek36AW34r_5wUAH8M7RBq11LjhQ'>
                                        <GoogleMap
                                            mapContainerStyle={mapStyles}
                                            zoom={zoom}
                                            center={currentPosition}
                                            clickableIcons={false}
                                            options={{'disableDefaultUI': true}}
                                        >
                                            <Autocomplete
                                                onLoad={onLoad}
                                                onPlaceChanged={onPlaceChanged}
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Ingrese el domicilio sin piso ni dto"
                                                    style={{
                                                        textAlign: `center`,
                                                        boxSizing: `border-box`,
                                                        border: `1px solid transparent`,
                                                        width: `70%`,
                                                        height: `32px`,
                                                        padding: `0 12px`,
                                                        borderRadius: `3px`,
                                                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                        fontSize: `14px`,
                                                        outline: `none`,
                                                        textOverflow: `ellipses`,
                                                        position: "absolute",
                                                        left: "50%",
                                                        marginLeft: "-180px"
                                                    }}
                                                />
                                            </Autocomplete>
                                            <Marker position={currentPosition}/>
                                        </GoogleMap>
                                    </LoadScript>
                                </Drawer>
                            </Drawer>
                        </Content>
                    </Layout>
                </Layout>
            </ConfigProvider>
        </>
    );

}

export default Pacients;
